<template>
  <div class="table">
    <div class="container">
      <div class="handle-box">
        <el-form label-width="120px" ref="queryCondition" :model="queryCondition" label-position="right" class="searchForm">
          <el-row>
            <el-col :span="24">
              <el-row :gutter="20">
                <el-col :span="6">
                  <el-form-item label="单据编号" prop="applyNo">
                    <el-input class="handle-input" v-model="queryCondition.applyNo" clearable placeholder="请输入单据编号" style="width:100%"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="主题" prop="subject">
                    <el-input class="handle-input" v-model="queryCondition.subject" clearable placeholder="请输入主题" style="width:100%"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="入围供应商" prop="supplierCode">
                    <el-input class="handle-input" :disabled="true" v-model="queryCondition.supplierCode" style="width:100%"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="类型" prop="applyType">
                    <el-select v-model="queryCondition.applyType" placeholder="类型" clearable style="width:100%">
                      <el-option :label="$t('common.all')" value></el-option>
                      <el-option :key="index" v-for="(item,index) in applyTypeOptions" :label="item | inputChoiceI18n" :value="item.code"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-col>
            <el-collapse-transition>
              <el-col :span="24" v-if="isShow">
                <el-row :gutter="20">
                  <el-col :span="6">
                    <el-form-item label="创建人" prop="name">
                      <el-input class="handle-input" v-model="queryCondition.name" clearable placeholder="请输入创建人" style="width:100%"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="6">
                    <el-form-item label="创建日期(从)" prop="createDate">
                      <el-date-picker v-model="queryCondition.createDate" type="date" placeholder="选择日期" value-format="yyyy-MM-dd" style="width:100%"></el-date-picker>
                    </el-form-item>
                  </el-col>
                  <el-col :span="6">
                    <el-form-item label="创建日期(至)" prop="createEndDate">
                      <el-date-picker value-format="yyyy-MM-dd" v-model="queryCondition.createEndDate" type="date" :placeholder="$t('common.selDate')" style="width:100%"></el-date-picker>
                    </el-form-item>
                  </el-col>
                  <el-col :span="6">
                    <el-form-item label="8位码" prop="eightBitCodesStr">
                      <el-input v-model="queryCondition.eightBitCodesStr" type="textarea" :autosize="{ minRows: 2, maxRows: 4}" clearable class="handle-input" placeholder="请输入8位码" style="width:100%"></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
              </el-col>
            </el-collapse-transition>
          </el-row>
          <el-row type="flex" justify="center" align="middle">
            <el-button size="mini" @click="queryData(1)" type="primary">{{$t('common.search')}}</el-button>
            <el-button size="mini" @click="restQueryFormThis()" type="primary">{{$t('common.reset')}}</el-button>
            <span class="arrowDown" @click="isShow=!isShow">{{isShow?'收缩':'展开'}}<i :class="isShow?'el-icon-arrow-up iconBtn':'el-icon-arrow-down iconBtn'"></i></span>
          </el-row>
        </el-form>
      </div>
      <div class="action-btn-row">
        <el-button size="mini" class="btn" type="primary" v-acl="ProApplyAddSp" @click="addNewApply(-1)">新增</el-button>
        <el-button size="mini" class="btn" type="danger" v-acl="ProApplyDeleteApply" @click="delApply()">删除</el-button>
        <el-button size="mini" class="btn" type="primary" v-acl="ProApplyCloseApplySp" @click="closeApply()">作废</el-button>
      </div>
      <el-table :data="tableData" border max-height="470" highlight-current-row>
        <el-table-column align="center" fixed width="56" :label="$t('common.select')">
          <template slot-scope="scope">
            <el-radio :disabled="scope.row.status=='3'" v-model="radioVal" @change.native="getSelectRow(scope.row)" :label="scope.row.ttQuotationApplyId">&nbsp;</el-radio>
          </template>
        </el-table-column>
        <el-table-column show-overflow-tooltip sortable prop="applyNo" label="单据编号" fixed>
          <template slot-scope="scope">
            <el-link type="primary" @click="openQuotationApplyDetail(scope.row)">{{scope.row.applyNo}}</el-link>
          </template>
        </el-table-column>
        <el-table-column show-overflow-tooltip sortable prop="subject" label="主题"></el-table-column>
        <el-table-column show-overflow-tooltip sortable prop="supplierNames" label="入围供应商"></el-table-column>
        <el-table-column show-overflow-tooltip sortable prop="name" label="创建人"></el-table-column>
        <el-table-column show-overflow-tooltip sortable prop="createDate" label="创建日期"></el-table-column>
        <el-table-column show-overflow-tooltip sortable prop="statusI18n" label="申请单状态"></el-table-column>
      </el-table>
      <div class="pagination">
        <!--===分页组件===-->
        <el-pagination @size-change="pageSizeChange" @current-change="pageNumberChange" :current-page="queryCondition.pageNum" :page-sizes="pageSizeList" :page-size="queryCondition.pageSize" :layout="pageLayout" :total="totalCount"></el-pagination>
      </div>

      <el-dialog :visible.sync="showSelSupplierDialog" append-to-body width="80%">
        <SelSupplier ref="supplierSelRef" @subCallMethod="selectSupplierMethod"></SelSupplier>
      </el-dialog>
    </div>
  </div>
</template>
<script>
import {
  getProApplyList,
  delSelQuotationApply,
  closeApplyInfo
} from "@/api/quoteByProduct.js";
import { inputChoiceService } from "@/api/common/input-choice";
import commonFunction from "@/utils/dataTableUtils";
import SelSupplier from "@/components/page/base-data/carrier-sel-page";
import store from '@/store/index'
import paginationMixin from '../../../../mixins/pagitionMixin';
export default {
  name: "productQuotationApplicationSp",
  mixins: [paginationMixin],
  components: {
    SelSupplier
  },
  data() {
    return {
      isShow: false,//控制查询列表收缩展开
      radioVal: null,
      selectRow: null,
      showSelSupplierDialog: false,
      eightLists: [],
      queryCondition: {
        pageSize: 15,
        pageNum: 1,
        applyNo: null,
        subject: null,
        applyType: null,
        supplierCode: null,
        name: null,
        createDate: null,
        createEndDate: null,
        eightBitCodesStr: null,
        eightBitCodes: []
      },
      applyTypeOptions: [],
      statusListOptions: [],
      quotationStatusOptions: [],
      sourcingStatusOptions: [],
      tableData: [],
      totalCount: 0,
      supplierCode: ""
    };
  },
  created() {
    // this.queryData(1);
    this.getInputChoiceValues();
  },
  watch: {
    queryCondition() {
      let _this = this;
      store.dispatch('uploadListParams', { routeName: _this.$route.name, reqData: _this.queryCondition })
    }
  },
  beforeRouteEnter(to, from, next) {
    const eightBitCodesStr = to.meta.reqData.eightBitCodesStr
    let eightBitCodesArr = []
    if (eightBitCodesStr && eightBitCodesStr.length > 0) {
      eightBitCodesArr = eightBitCodesStr.trim().split(/[\n,，; \s]+/g);
    }
    const requestData = Object.assign({}, to.meta.reqData)
    requestData.eightBitCodes = eightBitCodesArr
    getProApplyList(requestData).then((res) => {
      next(vm => {
        vm.queryCondition = requestData;
        vm.tableData = res.resultData;
        vm.totalCount = res.totalCount;
        vm.supplierCode = res.otherInfo;
      })
    })
  },
  methods: {
    queryData(val) {
      if (undefined != val) {
        this.queryCondition.pageNum = 1;
      }
      const eightBitCodesStr = this.queryCondition.eightBitCodesStr
      let eightBitCodesArr = []
      if (eightBitCodesStr && eightBitCodesStr.length > 0) {
        eightBitCodesArr = eightBitCodesStr.trim().split(/[\n,，; \s]+/g);
      }
      const requestData = Object.assign({}, this.queryCondition)
      this.$set(requestData, 'eightBitCodes', eightBitCodesArr)
      getProApplyList(requestData).then(res => {
        this.tableData = res.resultData;
        this.totalCount = res.totalCount;
        this.supplierCode = res.otherInfo;
      });
    },
    // onChangeClick(val) {
    //   console.log('8位码:', val);
    //   this.eightLists = []
    //   var arr = val.split(';')
    //   for (let i = 0; i < arr.length; i++) {
    //     this.eightLists.push({
    //       aaa: arr[i]
    //     })
    //   }
    // },
    getInputChoiceValues() {
      let mapObj = {};
      mapObj["TT_QUOTATION_APPLY:STATUS"] = "TT_QUOTATION_APPLY:STATUS";
      mapObj["TT_QUOTATION:STATUS"] = "TT_QUOTATION:STATUS";
      mapObj["TT_SOURCING:STATUS"] = "TT_SOURCING:STATUS";
      mapObj["TT_QUOTATION_APPLY:PRODUCT_APPLY_TYPE"] =
        "TT_QUOTATION_APPLY:PRODUCT_APPLY_TYPE";
      mapObj["TT_QUOTATION_APPLY:APPLY_TYPE"] = "TT_QUOTATION_APPLY:APPLY_TYPE";
      inputChoiceService.getInputChoiceValues(mapObj).then(res => {
        this.applyTypeOptions = res["TT_QUOTATION_APPLY:PRODUCT_APPLY_TYPE"];
        this.statusListOptions = res["TT_QUOTATION_APPLY:STATUS"];
        this.quotationStatusOptions = res["TT_QUOTATION:STATUS"];
        this.sourcingStatusOptions = res["TT_SOURCING:STATUS"];
      });
    },
    addNewApply(id) {
      this.$router.push({
        path: `/product-quotation-application-sp-add`,
        query: { applyId: id }
      });
    },
    openQuotationApplyDetail: function (row) {
      this.$router.push({
        path: `/product-quotation-application-sp-add`,
        query: {
          applyId: row.ttQuotationApplyId,
          source: "apply",
          applyType: row.applyType
        }
      });
    },
    //单选操作
    getSelectRow: function (row) {
      this.selectRow = [];
      this.selectRow = row;
    },
    selectSupplierMethod: function (supList) {
      this.queryCondition.supplierCode = supList[0].supplierCode;
      this.queryCondition.tmSupplierId = supList[0].tmSupplierId;
      this.showSelSupplierDialog = false;
    },
    delApply() {
      var that = this;
      if (this.selectRow == null) {
        //请选择需要删除的申请单
        that.$message({
          message: this.$t("apply.selectDelApply"),
          type: "warning"
        });
      } else {
        let delId = that.selectRow.ttQuotationApplyId;
        //判断单据是否为草稿状态
        if (that.selectRow.status != "1") {
          //只有草稿状态的申请单才可以删除
          that.$message({
            message: this.$t("apply.delApplyParam"),
            type: "warning"
          });
          return;
        }
        // //请确认是否删除!
        that
          .$confirm(that.$t("common.delConfirm"), that.$t("common.tips"), {
            confirmButtonText: that.$t("common.confirm"),
            cancelButtonText: that.$t("common.cancel"),
            type: "warning"
          })
          .then(() => {
            delSelQuotationApply(delId).then(res => {
              if (res.meta.success) {
                that.selectRow = null;
                that.radioVal = null;
                that.$message({
                  message: that.$t("common.delSuccess"),
                  type: "success"
                });
                that.queryData();
              } else {
                that.$message({
                  message: that.$t("common.delError"),
                  type: "error"
                });
              }
            });
          })
          .catch(() => { });
      }
    },
    closeApply() {
      let that = this;
      if (this.selectRow == null) {
        //请选择需要作废的申请单!
        that.$message({
          message: this.$t("apply.selectCloseApply"),
          type: "warning"
        });
      } else {
        let delId = this.selectRow.ttQuotationApplyId;
        //请确认是否关闭
        this.$confirm(this.$t("common.closeConfirm"), this.$t("common.tips"), {
          confirmButtonText: this.$t("common.confirm"),
          cancelButtonText: this.$t("common.cancel"),
          type: "warning"
        })
          .then(() => {
            closeApplyInfo(delId).then(res => {
              if (res.meta.success) {
                this.selectRow = null;
                this.radioVal = null;
                that.$message({
                  message: this.$t("common.closeSuccess"),
                  type: "success"
                });
                this.queryData();
              } else {
                that.$message({
                  message: this.$t("common.closeError"),
                  type: "error"
                });
              }
            });
          })
          .catch(() => { });
      }
    },
    restQueryFormThis: function () {
      this.$refs.queryCondition.resetFields();
      this.queryCondition = {
        pageSize: 15,
        pageNum: 1,
        applyNo: null,
        subject: null,
        applyType: null,
        supplierCode: null,
        name: null,
        createDate: null,
        createEndDate: null,
        eightBitCodesStr: null,
        eightBitCodes: []
      }
      this.radioVal = ''
      this.queryData()
    }
  },
  extends: commonFunction
};
</script>
<style scoped lang="scss">
.productQuotationApplication {
  .toolsBox {
    margin-bottom: 10px;
  }
  .a-link {
    text-decoration: underline;
  }

  .el-select {
    width: 100%;
  }
  .el-date-editor.el-input,
  .el-date-editor.el-input__inner {
    width: 100%;
  }
}
</style>
<style lang="scss">
</style>